import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import styled from "styled-components";
import { Cancel } from "../../../../components/styled/AllImages";
import {
  ButtonStyled,
  HeadingStyled,
} from "../../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useUser } from "../../../../context/userContext";
import UsersApi from "../../../../services/api/usersApi";
import { stepsToTransfer } from "../../../../helpers/adminConstants/AdminConstants";

const TransferModal = ({
  show,
  onHide,
  onSubmit,
  transferLoading,
  selections,
  setSelections,
  currentStep,
  setCurrentStep,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { user } = useUser();
  const [usersListByDepId, setUsersListByDepId] = useState([]);

  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm();

  const handleClose = () => {
    let selection = Array(stepsToTransfer.length).fill(null);

    onHide();
    setCurrentStep(0);
    setSelections(selection);
  };

  const handleNext = () => {
    if (currentStep < stepsToTransfer.length - 1) {
      if (
        currentStep === 0 &&
        selections[currentStep] == user?.department?.id
      ) {
        setCurrentStep(stepsToTransfer.length - 1);
      } else {
        setCurrentStep(currentStep + 1);
      }
    } else {
      setCurrentStep(0);
      setSelections(Array(stepsToTransfer.length).fill(null));
      onHide();
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      if (
        currentStep === stepsToTransfer.length - 1 &&
        selections[0] == user?.department?.id
      ) {
        setCurrentStep(0);
      } else {
        setCurrentStep(currentStep - 1);
      }
    }
  };

  const getUsersByDepartment = async (departmentId) => {
    try {
      const { data, code } = await UsersApi.getUsersByDepartment(departmentId);

      if (code === 200 && Array.isArray(data) && data?.length > 0) {
        const updatedUsers = data?.map((user) => ({
          ...user,
          subLabel: `${
            language === "en"
              ? user.user_detail.department.name_en
              : user.user_detail.department.name_ar
          }  (${
            language === "en"
              ? user.user_detail.office_location.name_en
              : user.user_detail.office_location.name_ar
          })`,
        }));
        setUsersListByDepId(updatedUsers);
      } else {
        setUsersListByDepId([]);
      }
    } catch (error) {}
  };

  const handleSelect = (e) => {
    let { value } = e.target;
    const newSelections = [...selections];
    if (value !== "other_departments") value = Number(value);
    newSelections[currentStep] = value;
    setSelections(newSelections);
  };

  useEffect(() => {
    if (
      selections &&
      selections[currentStep] &&
      selections[currentStep] != "other_departments" &&
      currentStep != 2
    ) {
      getUsersByDepartment(selections[currentStep]);
    }
  }, [selections]);

  const CurrentStepComponent = stepsToTransfer[currentStep].component;

  return (
    <Modal show={show} centered onHide={handleClose}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <StyledModalWrapper>
          <div className="d-flex justify-content-between align-items-center p-3">
            <HeadingStyled size="24px" color="var(--text)">
              {t(stepsToTransfer[currentStep].title)}
            </HeadingStyled>
            <span className="close-button cursor-pointer" onClick={handleClose}>
              <Cancel />
            </span>
          </div>
          <ScrollableContainer>
            <CurrentStepComponent
              onSelect={handleSelect}
              selected={selections[currentStep]}
              t={t}
              language={language}
              usersListByDepId={usersListByDepId}
            />
          </ScrollableContainer>
          <div className="modal-footer">
            {currentStep > 0 && (
              <ButtonStyled
                bg="var(--bgSecondary)"
                color="var(--text)"
                label={t("back")}
                onClick={handleBack}
                type="button"
              />
            )}
            {currentStep != stepsToTransfer.length - 1 && (
              <ButtonStyled
                label={t("next")}
                onClick={handleNext}
                disabled={selections[currentStep] === null}
                bg="var(--themeColor)"
                type="button"
              />
            )}
            {currentStep == stepsToTransfer.length - 1 && (
              <ButtonStyled
                isLoading={transferLoading}
                label={t("transfer")}
                disabled={selections[currentStep] === null}
                bg="var(--themeColor)"
                type="submit"
              />
            )}
          </div>
        </StyledModalWrapper>
      </Form>
    </Modal>
  );
};

export default TransferModal;

const StyledModalWrapper = styled.div`
  .modal-content {
    border-radius: 8px;
  }

  .option-text {
    border-top: 1px solid var(--borderLight);
  }

  .close-button {
    background: none;
    border: none;
    font-size: 1.5rem;
    padding: 0;
    line-height: 1;
  }

  .option-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    padding: 16px;
  }

  .action-button {
    margin-left: 8px;
  }
`;
const ScrollableContainer = styled.div`
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 10px;
  border-radius: 12px;
  padding: 8px;

  /* Scrollbar Styles */
  &::-webkit-scrollbar {
    width: 7px;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: var(--bgSecondary);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #e4e8ef;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #b8c0cc;
  }
`;